// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.user_wrapper__aQix\\+ {
  display: flex;
}

.user_title__3CIL4 {
  font-weight: 700;
  font-size: 3rem;
}

.user_content__DeMqB {
  text-align: justify;
}

.user_search-user__0YPNW {
  padding: 10px 50px 10px 5px;
  font-size: 1.6rem;
}
.user_search-user__0YPNW:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.user_add-btn__GEip3 {
  font-size: 1.6rem;
  border-radius: 8px;
}

.user_content-wrap__NpH-1 {
  word-wrap: break-word; /* Cho phép nội dung tự động xuống dòng */
  overflow-wrap: break-word; /* Hỗ trợ cho trình duyệt mới */
  white-space: normal; /* Không giữ nội dung trên cùng một dòng */
}

@media (max-width: 1024px) {
  .user_wrapper__aQix\\+ {
    display: block;
  }
}
@media (max-width: 1024px) and (max-width: 768px) {
  img {
    max-width: 100%;
    height: auto;
    display: block; /* Tránh lỗi khoảng trắng dưới ảnh */
    object-fit: cover; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */
  }
  .user_title__3CIL4 {
    width: 80%;
    font-size: 2.4rem;
  }
}
@media (max-width: 1024px) and (min-width: 769px) and (max-width: 1200px) {
  img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important; /* Tránh lỗi khoảng trắng dưới ảnh */
    object-fit: contain; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */
  }
  .user_title__3CIL4 {
    width: 90%;
    font-size: 2.4rem;
  }
}
.user_member-wapper__L41T\\+ {
  max-width: 800px; /* Đặt chiều rộng cố định giống nhau */
  margin: auto;
  text-align: left;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/post/user.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;AAEJ;;AACA;EACI,gBAAA;EACA,eAAA;AAEJ;;AAAA;EACI,mBAAA;AAGJ;;AADA;EACI,2BAAA;EACA,iBAAA;AAIJ;AAFI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAIR;;AADA;EACI,iBAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,qBAAA,EAAA,yCAAA;EACA,yBAAA,EAAA,+BAAA;EACA,mBAAA,EAAA,0CAAA;AAKJ;;AADA;EACI;IACI,cAAA;EAIN;AACF;AAFI;EACI;IACI,eAAA;IACA,YAAA;IACA,cAAA,EAAA,oCAAA;IACF,iBAAA,EAAA,6DAAA;EAIR;EAFM;IACE,UAAA;IACA,iBAAA;EAIR;AACF;AAFI;EACI;IACI,0BAAA;IACR,uBAAA;IACA,yBAAA,EAAA,oCAAA;IACQ,mBAAA,EAAA,6DAAA;EAIV;EAFQ;IACE,UAAA;IACA,iBAAA;EAIV;AACF;AACA;EACI,gBAAA,EAAA,sCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AACJ","sourcesContent":[".wrapper{\n    display: flex;\n}\n\n.title{\n    font-weight: 700;\n    font-size: 3rem;\n}\n.content{\n    text-align: justify;\n}\n.search-user{\n    padding: 10px 50px 10px 5px;\n    font-size: 1.6rem;\n    \n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.add-btn{\n    font-size: 1.6rem;\n    border-radius: 8px;\n}\n.content-wrap {\n    word-wrap: break-word;     /* Cho phép nội dung tự động xuống dòng */\n    overflow-wrap: break-word; /* Hỗ trợ cho trình duyệt mới */\n    white-space: normal;       /* Không giữ nội dung trên cùng một dòng */\n  }\n  \n\n@media (max-width: 1024px) {\n    .wrapper{\n        display: block;\n    }\n    \n    @media (max-width: 768px) {\n        img {\n            max-width: 100%;\n            height: auto;\n            display: block; /* Tránh lỗi khoảng trắng dưới ảnh */\n          object-fit: cover; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */\n        }\n        .title{\n          width: 80%;\n          font-size: 2.4rem;\n        }\n      }\n    @media (min-width: 769px) and (max-width: 1200px){\n        img {\n            max-width: 100% !important;\n    height: auto !important;\n    display: block !important; /* Tránh lỗi khoảng trắng dưới ảnh */\n            object-fit: contain; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */\n          }\n          .title{\n            width: 90%;\n            font-size: 2.4rem;\n          }\n    \n    }\n}   \n\n.member-wapper {\n    max-width: 800px; /* Đặt chiều rộng cố định giống nhau */\n    margin: auto;\n    text-align: left;\n    padding: 10px 20px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n  }\n  \n\n  \n  \n  \n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `user_wrapper__aQix+`,
	"title": `user_title__3CIL4`,
	"content": `user_content__DeMqB`,
	"search-user": `user_search-user__0YPNW`,
	"add-btn": `user_add-btn__GEip3`,
	"content-wrap": `user_content-wrap__NpH-1`,
	"member-wapper": `user_member-wapper__L41T+`
};
export default ___CSS_LOADER_EXPORT___;
